// extracted by mini-css-extract-plugin
export var background = "_77-0";
export var container = "_77-1";
export var contentItem = "_77-7";
export var extendedWarranty = "_77-5";
export var link = "_77-d";
export var modal = "_77-b";
export var modalCloseButton = "_77-9";
export var modalContent = "_77-3";
export var modalContentMain = "_77-6";
export var modalImageLogo = "_77-8";
export var modalLogo = "_77-a";
export var modalSideImage = "_77-4";
export var preview = "_77-c";
export var redoModal = "_77-2";